<template>
  <div class="big-box">
    <img :src="backgroundImage" alt="" class="big-box-img" />
    <div class="big-body">
      <img :src="tapTopUrl" alt="" class="tap-top" />
      <div class="pd8">
        <!-- 主题文字 -->
        <div
          class="theme-word"
          :style="`color: ${customerPaperwork.titleColor};`"
        >
          <span>{{ customerPaperwork.title }}</span>
          <span>{{ customerPaperwork.desc }}</span>
        </div>
        <!-- 音效 -->
        <div class="mp3" v-if="customerPaperwork.musicOpen == '1'">
          <img
            src="https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/hd/20260205/953baeba3ff5420f8a17a6b266509f3d.png"
            v-if="customerPaperwork.iconColor == '2'"
          />
          <img
            src="https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/hd/20260205/3ec3c785948d460a879876513d375876.png"
            v-else
          />
        </div>
        <div class="tab-box" :style="{ width: `${wishingPrizeList.length*85}px` }">
          <div
            class="tab-item"
            :style="{ width: `${wishingPrizeList.length*85}px` }"
            v-for="(item, index) in wishingPrizeList"
            :key="index"
            @click="changeTab(index)"
          >
            <img
              class="tab-img"
              :src="tabUrl"
              alt=""
              v-show="index == currentIndex"
            />
            <span
              class="tab-name"
              :style="`color: ${
                index == currentIndex
                  ? customerPaperwork.tabSelectedColor
                  : customerPaperwork.tabUnSelectedColor
              };`"
              >{{ item.poolName }}</span
            >
          </div>
        </div>
        <div
          class="prize-box"
          :style="{
            'margin-top': wishingPrizeList.length > 1 ? '12px' : '48px',
          }"
          v-if="currentPrize.length > 0"
        >
          <div class="prize-item prize-item1">
            <img :src="currentPrize[0].logo" alt="" class="logo" />
            <div
              class="prizeName"
              :style="{
                backgroundColor: customerPaperwork.prizeNameBgColor,
                color: customerPaperwork.prizeNameColor,
              }"
            >
              {{ currentPrize[0].title }}
            </div>
            <div class="prizeAmount" v-if="customerPaperwork.stock == 1">
              x{{
                currentPrize[0].remanentAmount
                  ? currentPrize[0].remanentAmount
                  : currentPrize[0].totalAmount
              }}
            </div>
          </div>
          <div class="prize-item prize-item2" v-if="currentPrize.length >= 2">
            <img :src="currentPrize[1].logo" alt="" class="logo" />
            <div
              class="prizeName"
              :style="{
                backgroundColor: customerPaperwork.prizeNameBgColor,
                color: customerPaperwork.prizeNameColor,
              }"
            >
              {{ currentPrize[1].title }}
            </div>
            <div class="prizeAmount" v-if="customerPaperwork.stock == 1">
              x{{
                currentPrize[1].remanentAmount
                  ? currentPrize[1].remanentAmount
                  : currentPrize[1].totalAmount
              }}
            </div>
          </div>
          <div class="prize-item prize-item3" v-if="currentPrize.length >= 3">
            <img :src="currentPrize[2].logo" alt="" class="logo" />
            <div
              class="prizeName"
              :style="{
                backgroundColor: customerPaperwork.prizeNameBgColor,
                color: customerPaperwork.prizeNameColor,
              }"
            >
              {{ currentPrize[2].title }}
            </div>
            <div class="prizeAmount" v-if="customerPaperwork.stock == 1">
              x{{
                currentPrize[2].remanentAmount
                  ? currentPrize[2].remanentAmount
                  : currentPrize[2].totalAmount
              }}
            </div>
          </div>
          <div class="prize-item prize-item4" v-if="currentPrize.length >= 4">
            <img :src="currentPrize[3].logo" alt="" class="logo" />
            <div
              class="prizeName"
              :style="{
                backgroundColor: customerPaperwork.prizeNameBgColor,
                color: customerPaperwork.prizeNameColor,
              }"
            >
              {{ currentPrize[3].title }}
            </div>
            <div class="prizeAmount" v-if="customerPaperwork.stock == 1">
              x{{
                currentPrize[3].remanentAmount
                  ? currentPrize[3].remanentAmount
                  : currentPrize[3].totalAmount
              }}
            </div>
          </div>
          <div class="prize-item prize-item5" v-if="currentPrize.length >= 5">
            <img :src="currentPrize[4].logo" alt="" class="logo" />
            <div
              class="prizeName"
              :style="{
                backgroundColor: customerPaperwork.prizeNameBgColor,
                color: customerPaperwork.prizeNameColor,
              }"
            >
              {{ currentPrize[4].title }}
            </div>
            <div class="prizeAmount" v-if="customerPaperwork.stock == 1">
              x{{
                currentPrize[4].remanentAmount
                  ? currentPrize[4].remanentAmount
                  : currentPrize[4].totalAmount
              }}
            </div>
          </div>
          <div class="prize-item prize-item6" v-if="currentPrize.length >= 6">
            <img :src="currentPrize[5].logo" alt="" class="logo" />
            <div
              class="prizeName"
              :style="{
                backgroundColor: customerPaperwork.prizeNameBgColor,
                color: customerPaperwork.prizeNameColor,
              }"
            >
              {{ currentPrize[5].title }}
            </div>
            <div class="prizeAmount" v-if="customerPaperwork.stock == 1">
              x{{
                currentPrize[5].remanentAmount
                  ? currentPrize[5].remanentAmount
                  : currentPrize[5].totalAmount
              }}
            </div>
          </div>
          <div class="prize-item prize-item7" v-if="currentPrize.length >= 7">
            <img :src="currentPrize[6].logo" alt="" class="logo" />
            <div
              class="prizeName"
              :style="{
                backgroundColor: customerPaperwork.prizeNameBgColor,
                color: customerPaperwork.prizeNameColor,
              }"
            >
              {{ currentPrize[6].title }}
            </div>
            <div class="prizeAmount" v-if="customerPaperwork.stock == 1">
              x{{
                currentPrize[6].remanentAmount
                  ? currentPrize[6].remanentAmount
                  : currentPrize[6].totalAmount
              }}
            </div>
          </div>
        </div>
        <div class="report-box" v-if="ruleDTO.showMemoryBook">
          <img
            src="https://cdn-image.yucrm.cn/47a697177b2149fbb4b6bf69e6d5ba11.png"
            alt=""
          />
        </div>
        <div class="tip">
          <div class="tip-text">
            消耗{{ currentObj.consumeCoins || 0 }}枚许愿币点亮奖品池
          </div>
          <img
            src="https://cdn-image.yucrm.cn/5cd30589cb23451f9321d5d7a626cdc1.png"
            alt=""
          />
        </div>
        <div class="btn-box">
          <img :src="btnUrl" alt="" class="btn" />
          <div class="btn-text" :style="{ color: customerPaperwork.btnColor }">
            立即许愿
          </div>
        </div>
        <div class="wish-box">
          <img
            src="https://cdn-image.yucrm.cn/c9a501b889654835b11df8825f7c2254.png"
            alt=""
          />
        </div>
        <div class="time-text">抽奖时间{{ getTimeText }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  mixins: [],
  props: {
    ruleForm: {
      type: Object,
      default: () => ({}),
    },
    ruleDTO: {
      type: Object,
      default: () => ({}),
    },
    wishingPrizeList: {
      type: Array,
      default: () => [],
    },
    customerPaperwork: {
      type: Object,
      default: () => ({}),
    },
    templateObj: {
      type: Object,
      default: () => ({}),
    },
    backgroundImage: {
      type: String,
      default: "",
    },
    getTimeText: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      currentObj: {},
      currentPrize: [],
      currentIndex: 0,
      prizeList: [],
      tapTopUrl:
        "https://cdn-image.yucrm.cn/images/dyAssets/images/preview/shop_top.png",
      inviteNumImg:
        "https://cdn-image.yucrm.cn/images/dyAssets/images/preview/yqrs_footer.png",
    };
  },
  computed: {
    timeType() {
      if (this.ruleForm.timeType === "day") {
        return "生日当天";
      } else if (this.ruleForm.timeType === "week") {
        return "生日当周";
      } else if (this.ruleForm.timeType === "month") {
        return "生日当月";
      }
    },
    tabUrl() {
      return this.customerPaperwork.tabUrl
        ? this.customerPaperwork.tabUrl
        : this.templateObj.url3;
    },
    btnUrl() {
      return this.customerPaperwork.btnUrl
        ? this.customerPaperwork.btnUrl
        : this.templateObj.url2;
    },
  },
  watch: {
    wishingPrizeList: {
      handler(newVal) {
        let arr = newVal[this.currentIndex].prizeSettingList;
        this.currentObj = newVal[this.currentIndex];
        this.currentPrize = arr.filter(
          (item) => item.prizeType && item.prizeType != 9
        );
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {},
  methods: {
    changeTab(index) {
      this.currentIndex = index;
      this.currentObj = this.wishingPrizeList[index];
      this.currentPrize = this.wishingPrizeList[index].prizeSettingList.filter(
        (item) => item.prizeType && item.prizeType != 9
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.big-box {
  position: relative;
  width: 300px;
  height: 580px;
  box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
  border-radius: 24px;
  border: 1px solid #ffffff;
  padding: 8px;
  // margin-left: 231px;
  z-index: 999;
  background-color: #ffffff;
  .big-box-img {
    border-radius: 24px;
    width: 284px;
    height: 564px;
  }
  .big-body {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    .tap-top {
      width: 100%;
    }
    .pd8 {
      width: 100%;
      height: 100%;
      margin-top: 18px;
      // padding: 8px;
      box-sizing: border-box;
      position: relative;

      .theme-word {
        // position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        // top: 18px;
        width: 100%;
        > span:first-child {
          font-weight: bold;
          font-size: 18px;
          margin-bottom: 10px;
        }
        > span:last-child {
          font-size: 10px;
        }
      }
      .mp3 {
        width: 22px;
        height: 22px;
        position: absolute;
        top: 10px;
        left: 17px;
        > img {
          width: 100%;
          height: 100%;
        }
      }
      .bottomDom {
        position: absolute;
        top: 408px;
        left: 50%;
        transform: translateX(-50%);
        .prizeBody {
          width: 263px;
          background: rgba(255, 255, 255, 0.15);
          border-radius: 5px 5px 5px 5px;
          border: 0px solid rgba(255, 255, 255, 0.2);
          display: flex;
          flex-direction: column;
          align-items: center;
          .prizeTitle {
            background-image: url("https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/hd/20260205/d65bd6c9be844ad78b1e8015e17ff824.png");
            width: fit-content;
            height: 16px;
            background-size: 100% 100%;
            background-position: center;
            background-repeat: no-repeat;
            padding: 0 15px;
            line-height: 16px;
            font-weight: 400;
            font-size: 8px;
            color: #ffffff;
          }
          .validityPeriod {
            margin: 5px;
            font-weight: 400;
            font-size: 8px;
            color: rgba(255, 255, 255, 0.5);
          }
          .memberList {
            display: flex;
            align-items: center;
            width: 100%;
            overflow: hidden;
            padding-left: 10px;
            margin-bottom: 8px;
            > div {
              font-weight: 400;
              font-size: 8px;
              color: rgba(255, 238, 209, 0.5);
              border-bottom: 2px solid transparent;
              margin-right: 15px;
              // 文字不换行
              white-space: nowrap;
              > div {
                width: 100%;
                height: 2px;
                border-radius: 100px;
                margin-top: 4px;
              }
              .active {
                background: linear-gradient(
                  90deg,
                  rgba(255, 238, 209, 1),
                  rgba(255, 238, 209, 0)
                );
              }
            }
            > div:first-child {
              font-weight: bold;
              font-size: 8px;
              color: #ffeed1;
            }
          }
          .prizeList {
            display: flex;
            align-items: center;
            width: 100%;
            overflow: hidden;
            padding-left: 10px;
            margin-bottom: 8px;
            > img {
              width: 38px;
              height: 38px;
              border-radius: 3px 3px 3px 3px;
              margin-right: 8px;
            }
          }
        }
        .btnDom {
          margin: 0 auto;
          width: 181px;
          height: 38px;
          background-size: 100% 100%;
          background-position: center;
          background-repeat: no-repeat;
          font-weight: bold;
          font-size: 15px;
          text-align: center;
          line-height: 38px;
          margin-top: 20px;
          cursor: pointer;
          margin-bottom: 10px;
        }
      }
    }
    .action {
      position: absolute;
      top: 310px;
      width: 100%;
      height: 100px;
      text-align: center;
      .info {
        font-weight: 400;
        font-size: 10px;
        color: #ffffff;
        line-height: 10px;
        text-align: center;
      }
      .btn {
        margin: 8px auto;
        position: relative;
        width: 144px;
        height: 29px;
        border-radius: 25px;
        .btn-bg {
          width: 100%;
          height: 100%;
          border-radius: 25px;
        }
        &-text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-weight: 500;
          font-size: 12px;
          color: #343229;
          text-align: center;
        }
      }
    }
    .goods {
      box-sizing: border-box;
      position: absolute;
      top: 380px;
      left: 50%;
      width: 250px;
      height: 220px;
      transform: translate(-50%, 0);
      background: rgba(255, 255, 255, 0.6);
      box-shadow: 4px 0px 4px 0px rgba(201, 160, 166, 0.3);
      border-radius: 12px;
      border: 1px solid #ffffff;
      padding: 14px 0 0 14px;
      overflow-x: auto;
      overflow-y: hidden;
      &-top {
        margin-top: 14px;
        width: 80%;
        margin-left: 16px;
        position: relative;
        .line {
          width: 100%;
          border: 1px dashed #fd97ac;
        }
        .btn {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 65px;
          height: 17px;
          text-align: center;
          line-height: 15px;
          background: #f75073;
          font-size: 10px;
          color: #ffffff;
          border-radius: 50px;
        }
      }
      &-time {
        margin-top: 16px;
        margin-right: 20px;
        font-weight: 400;
        font-size: 10px;
        color: #2d2f31;
        line-height: 10px;
        text-align: center;
      }
      &-style {
        margin-top: 10px;
        overflow-x: auto;
        overflow-y: hidden;
        width: 238px;
        .item {
          position: relative;
          flex-shrink: 0;
          margin-right: 14px;
          width: 95px;
          height: 120px;
          padding: 7px 11px;
          border-radius: 6px;
          text-align: center;
          background: url("https://cdn-image.yucrm.cn/images/dyAssets/images/preview/goods.png")
            no-repeat;
          background-size: 125px 159px;
          &-url {
            width: 73px;
            height: 73px;
            border-radius: 8px;
          }
          &-title {
            margin: 10px 0 7px;
            font-weight: 400;
            font-size: 13px;
            color: #2d2f31;
            line-height: 13px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          &-num {
            font-weight: 400;
            font-size: 11px;
            color: #999999;
            line-height: 11px;
          }
        }
      }
      &-item {
        display: flex;
        overflow-x: auto;
        overflow-y: hidden;
        // height: 100%;
      }
      .onetwo-style {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .more-activity {
    position: absolute;
    width: 60px;
    height: 60px;
    bottom: 125px;
    right: 6px;
  }
  .title {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    text-align: center;
  }
}

.tab-box {
  margin: 16px auto 0;
  // width: 254px;
  height: 24px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 14px 14px 14px 14px;
  display: flex;
  // justify-content: center;
  align-items: center;
  .tab-item {
    height: 24px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .tab-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 24px;
      border-radius: 14px 14px 14px 14px;
    }
    .tab-name {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 10px;
      color: #ffffff;
      text-align: center;
      font-style: normal;
      text-transform: none;
      position: relative;
      z-index: 1;
    }
  }
}

.prize-box {
  position: relative;
  height: 314px;
  box-sizing: border-box;
  .prize-item {
    width: 50px;
    height: 55px;
    .logo {
      width: 50px;
      height: 50px;
      border-radius: 25px;
    }
    .prizeName {
      position: absolute;
      bottom: -2px;
      z-index: 1;
      text-align: center;
      width: 50px;
      height: 14px;
      border-radius: 7px 7px 7px 7px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 9px;
      line-height: 14px;
    }
    .prizeAmount {
      position: absolute;
      top: 0;
      right: -2px;
      padding: 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(0, 0, 0, 0.4);
      border-radius: 6px 6px 6px 6px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 9px;
      color: #ffffff;
    }
  }
  .prize-item1 {
    position: absolute;
    left: 117px;
    top: 0;
  }

  .prize-item2 {
    position: absolute;
    top: 30px;
    left: 28px;
  }
  .prize-item3 {
    position: absolute;
    top: 23px;
    left: 218px;
  }
  .prize-item4 {
    position: absolute;
    top: 100px;
    left: 66px;
  }
  .prize-item5 {
    position: absolute;
    top: 80px;
    left: 172px;
  }
  .prize-item6 {
    position: absolute;
    top: 156px;
    left: 28px;
  }
  .prize-item7 {
    position: absolute;
    top: 146px;
    right: 33px;
  }
}
.btn-box {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 41px;
  width: 170px;
  height: 48px;
  img {
    width: 100%;
    height: 100%;
  }
  .btn-text {
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    transform: translate(-50%, -50%);
  }
}

.report-box {
  position: absolute;
  left: 12px;
  bottom: 45px;
  width: 42px;
  height: 38px;
  img {
    width: 100%;
    height: 100%;
  }
}

.wish-box {
  position: absolute;
  right: 12px;
  bottom: 45px;
  width: 42px;
  height: 38px;
  img {
    width: 100%;
    height: 100%;
  }
}

.time-text {
  width: 100%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
  font-style: normal;
  text-transform: none;
}
.tip {
  position: absolute;
  left: 100px;
  bottom: 85px;
  width: 154px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  .tip-text {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    // bottom: 0;
    // right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 11px;
    line-height: 16px;
    color: #141414;
    font-style: normal;
    text-transform: none;
  }
  img {
    width: 100%;
    height: 100%;
  }
}
@font-face {
  font-family: "pingfangshaohua";
  src: url("../../../../../assets/font/pingfangshaohua.woff2") format("woff2");
  font-weight: normal;
  font-style: normal;
}
</style>
